import { render, staticRenderFns } from "./QuizLevelStart.vue?vue&type=template&id=5def18fa&"
import script from "./QuizLevelStart.vue?vue&type=script&lang=js&"
export * from "./QuizLevelStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports